import { Agent, TypePagination, TypePaginationParams, TypePaginationResult, } from '@types'

type UserManagementState = {
  agents: Array<Agent>
  agentPagination: TypePagination
}

export const SET_AGENTS = 'reducers/userManagement/SET_AGENTS' as const
export const GET_AGENTS = 'reducers/userManagement/GET_AGENTS' as const
export const SEARCH_AGENTS = 'reducers/userManagement/SEARCH_AGENTS' as const
export const LOAD_MORE_AGENTS = 'reducers/userManagement/LOAD_MORE_AGENTS' as const
export const LOAD_MORE_SEARCH_AGENTS = 'reducers/userManagement/LOAD_MORE_SEARCH_AGENTS' as const

export const setAgents = (payload: TypePaginationResult<Agent>, append = false) => ({
  type: SET_AGENTS,
  payload,
  append,
})

export const getAgents = (pagination: TypePaginationParams, includeEndOfWork?: boolean, append = false) => ({
  type: GET_AGENTS,
  pagination,
  includeEndOfWork,
  append,
})

export const searchAgents = (pagination: TypePaginationParams, searchValue: string, append = false) => ({
  type: SEARCH_AGENTS,
  pagination,
  searchValue,
  append,
})

export const loadMoreAgents = (pagination: TypePaginationParams, includeEndOfWork?: boolean) => ({
  type: LOAD_MORE_AGENTS,
  pagination,
  includeEndOfWork,
  append: true,
})

export const loadMoreSearchAgents = (pagination: TypePaginationParams, searchValue: string) => ({
  type: LOAD_MORE_SEARCH_AGENTS,
  pagination,
  searchValue,
  append: true,
})

type AppStateAction =
  | ReturnType<typeof setAgents>
  | { type: 'persist/REHYDRATE' }

const initialState: UserManagementState = {
  agents: [],
  agentPagination: {
    count: 0,
    next: '',
    previous: '',
  },
}

const reducers = (state = initialState, action: AppStateAction) => {
  switch(action.type) {
    case 'persist/REHYDRATE':
      return Object.assign({}, initialState, state)
    case SET_AGENTS: {
      const mergedAgents = action.append ?
        state.agents.concat(action.payload.results) :
        action.payload.results

      const dedupedAgents = mergedAgents.filter(
        (agent, index, agents) => agents.findIndex(targetAgent => targetAgent.id === agent.id) === index
      )

      return Object.assign({}, state, {
        agents: dedupedAgents,
        agentPagination: action.payload.pagination,
      })
    }
    default:
      return state
  }
}

export default reducers
